"use strict";

exports.__esModule = true;
exports.UploadDirect = undefined;

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _util = require("./util");

var _error = require("./error");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// 直传
var UploadDirect = exports.UploadDirect = function () {
    function UploadDirect(config, extraConfig, handlers) {
        var _this = this;

        (0, _classCallCheck3["default"])(this, UploadDirect);

        this.extraConfig = (0, _assign2["default"])({
            retryCount: 0,
            timeout: 0
        }, extraConfig);
        this.file = config.file;
        this.token = config.token;
        this.uploadUrl = config.uploadUrl;
        this.progress = null;
        this.aborted = false;
        this.xhr = null;
        this.retryCount = 0;
        this.file.id = (0, _util.generateUUID)();
        this.xhrHandler = function (xhr) {
            return _this.xhr = xhr;
        };
        this.uploadProgress = function () {};
        this.onError = function () {};
        this.onComplete = function () {};
        (0, _assign2["default"])(this, handlers);
    }

    UploadDirect.prototype.getUploadType = function getUploadType() {
        return "uploadDirect";
    };

    UploadDirect.prototype.putFile = function putFile() {
        var _this2 = this;

        this.aborted = false;

        var formData = new FormData();
        formData.append("file", this.file);
        formData.append("token", this.token);
        if ('key' in this.extraConfig) {
            formData.append('key', this.extraConfig.key);
        }
        if ('mimeType' in this.extraConfig) {
            formData.append('mimeType', this.extraConfig.mimeType);
        }
        if ('deadline' in this.extraConfig) {
            formData.append('deadline', this.extraConfig.deadline);
        }
        var promise = (0, _util.request)(this.getUploadUrl(), {
            method: "POST",
            body: formData,
            onCreate: this.xhrHandler,
            timeout: this.extraConfig.timeout,
            onProgress: function onProgress(data) {
                var progress = (0, _util.getProgressInfoItem)(data.loaded, data.total);
                _this2.uploadProgress({ total: progress });
            }
        }).then(function (res) {
            _this2.onComplete(res);
        }, function (err) {

            var needRetry = err.isRequestError && err.code === 0 && !_this2.aborted;
            if (needRetry) {
                var notReachRetryCount = ++_this2.retryCount <= _this2.extraConfig.retryCount;
                if (notReachRetryCount) {
                    _this2.putFile();
                    return;
                }
            }

            if (_this2.aborted) {
                _this2.onError({ message: _error.abortErrorMessage });
            } else {
                _this2.onError(err);
            }
        });

        return promise;
    };

    UploadDirect.prototype.stop = function stop() {
        this.xhr.abort();
        this.xhr = null;
        this.aborted = true;
        this.retryCount = 0;
    };

    UploadDirect.prototype.getUploadUrl = function getUploadUrl() {
        return this.uploadUrl + "/file/upload";
    };

    return UploadDirect;
}();


//////////////////
// WEBPACK FOOTER
// ./src/uploadDirect.js
// module id = 199
// module chunks = 0